import { API_URL, INITIAL_TOKEN } from "../config/config";
import { getAuthToken, logout } from "./auth";

async function request(url, options = {}) {
  const token = getAuthToken();

  const headers = new Headers({
    Accept: "application/json",
    token: INITIAL_TOKEN,
    ...options.headers,
  });

  if (!(options.body instanceof FormData)) {
    headers.set("Content-Type", "application/json");
  }

  if (token) {
    headers.append("authorization", token);
  }

  try {
    const response = await fetch(`${API_URL}${url}`, {
      ...options,
      headers,
    });

    if (!response.ok) {
      if (response.status === 401) {
        logout();
        return Promise.reject(new Error("Session expired. Logging out."));
      }
      const errorData = await response
        .json()
        .catch(() => ({ message: response.statusText }));
      const error = new Error(errorData.message || "An error occurred");
      error.response = response;
      error.data = errorData;
      throw error;
    }

    if (response.status === 204) {
      return;
    }

    return response.json();
  } catch (error) {
    console.error("API Client Error:", error);
    throw error;
  }
}

export const apiClient = {
  get: (url, options) => request(url, { ...options, method: "GET" }),
  post: (url, data, options) =>
    request(url, {
      ...options,
      method: "POST",
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  put: (url, data, options) =>
    request(url, {
      ...options,
      method: "PUT",
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  patch: (url, data, options) =>
    request(url, {
      ...options,
      method: "PATCH",
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  delete: (url, options) => request(url, { ...options, method: "DELETE" }),
};
